<template>
  <layout title="FAQ">
    <div
      class="
        relative
        px-8
        pt-8
        pb-20
        mx-auto
        xl:px-5
        max-w-7xl
        sm:px-6
        lg:pt-10 lg:pb-28
      "
    >
      <div class="relative mx-auto max-w-7xl">
        <div class="flex flex-col justify-start">
          <h1
            class="
              text-3xl
              font-extrabold
              leading-9
              tracking-tight
              text-gray-900
              sm:text-4xl sm:leading-10
              mb-16
              sm:mb-16
              text-center
            "
          >
            Frequently Asked Questions
          </h1>
        </div>

        <div class="flex flex-row">
          <div class="md:w-56">
            <group-faq :groupsValues="groupsData"></group-faq>
          </div>
          <div class="flex-1">
            <faq @emitPosition="titlePosition"></faq>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
import Faq from "../Components/Layout/Faq/Faq.vue";
import GroupFaq from "../Components/Layout/Faq/GroupFaq.vue";

export default {
  props: {
    errors: Object,
  },
  components: {
    layout,
    GroupFaq,
    Faq,
  },
  data() {
    return {
      groups: [],
      groupsData: [],
    };
  },

  methods: {
    titlePosition(groupsData) {
      this.groupsData = groupsData;
    },
  },
  created() {},

  mounted() {},
};
</script>
